import axios from "axios";

// Size & Colour (handover 26 Oct 2026, section 6). A variant is one product +
// size + colour with its own SKU, barcodes and optional price / re-order level.
// Errors come back as 400 { errorCode, message } - show `message`.
const base_path = window.APP_CONFIG?.BASE_URL;
const R = `${base_path}/Api/SizeColour`;
const q = (v) => encodeURIComponent(v ?? "");

/* ---------------------------------------------------------------- masters */
export const getSubCategories = async (categoryID) => {
  const response = await axios.get(`${R}/GetSubCategories?categoryID=${q(categoryID)}`);
  return response.data;
};
// { guid?, categoryID, name, shortName, sizeSetID, sortOrder, updatedUser } -> { guid }
export const saveSubCategory = async (data) => {
  const response = await axios.post(`${R}/SaveSubCategory`, data);
  return response.data;
};
export const deleteSubCategory = async (data) => {
  const response = await axios.post(`${R}/DeleteSubCategory`, data);
  return response.data;
};

// each with sizes[]
export const getSizeSets = async () => {
  const response = await axios.get(`${R}/GetSizeSets`);
  return response.data;
};
// { guid?, code, name, sortOrder, sizes: [{ guid?, code, name, isCore }] } -> { guid }
export const saveSizeSet = async (data) => {
  const response = await axios.post(`${R}/SaveSizeSet`, data);
  return response.data;
};
export const deleteSizeSet = async (data) => {
  const response = await axios.post(`${R}/DeleteSizeSet`, data);
  return response.data;
};

export const getSizes = async (sizeSetID) => {
  const response = await axios.get(`${R}/GetSizes?sizeSetID=${q(sizeSetID)}`);
  return response.data;
};
// { guid?, sizeSetID, code, name, sortOrder?, isCore } -> { guid }
export const saveSize = async (data) => {
  const response = await axios.post(`${R}/SaveSize`, data);
  return response.data;
};
export const deleteSize = async (data) => {
  const response = await axios.post(`${R}/DeleteSize`, data);
  return response.data;
};

export const getColours = async () => {
  const response = await axios.get(`${R}/GetColours`);
  return response.data;
};
// { guid?, code, name, hexCode (#RRGGBB), sortOrder? } -> { guid }
export const saveColour = async (data) => {
  const response = await axios.post(`${R}/SaveColour`, data);
  return response.data;
};
export const deleteColour = async (data) => {
  const response = await axios.post(`${R}/DeleteColour`, data);
  return response.data;
};

/* ---------------------------------------------------------------- variants */
// auto EAN-13 barcodes for a preview ("20" + a running number); not reserved
export const getNextBarcodes = async (count) => {
  const response = await axios.get(`${R}/NextBarcodes?count=${count}`);
  return response.data;
};
// { sizeSetID, onlyAddNew, removeMissing, autoBarcode, updatedUser,
//   variants: [{ productID, sizeID, colourID, salesRate?, reorderLevel?, isActive?, barcodes: [{ barcode, barcodeType, source }] }] }
// -> rows with variantID, sku, isNew, skipped, barcodes
export const saveVariants = async (data) => {
  const response = await axios.post(`${R}/SaveVariants`, data);
  return response.data;
};
export const getVariants = async (productIDs) => {
  const response = await axios.get(`${R}/GetVariants?productIDs=${q((productIDs || []).join(","))}`);
  return response.data;
};
// deletes, or makes inactive when transactions use them
export const deleteVariants = async (data) => {
  const response = await axios.post(`${R}/DeleteVariants`, data);
  return response.data;
};
// a scan -> its product / variant; 404 = no match
export const getByBarcode = async (barcode) => {
  const response = await axios.get(`${R}/GetByBarcode?barcode=${q(barcode)}`);
  return response.data;
};
export const setLabelPrinted = async (data) => {
  const response = await axios.post(`${R}/SetLabelPrinted`, data);
  return response.data;
};

/* ---------------------------------------------------------------- reports */
// POST Report/{SC-xx} with the filter body -> { resultName: [rows] }
export const getSizeColourReport = async (code, filters) => {
  const response = await axios.post(`${R}/Report/${code}`, filters);
  return response.data;
};
